import { z } from 'zod';
export const licenseClaimsV1Schema = z
    .object({
    schemaVersion: z.literal(1),
    subject: z.string().min(1),
    issuedAt: z.number().int().optional(),
    notBefore: z.number().int().optional(),
    expiresAt: z.number().int().optional(),
    plan: z.string().optional(),
    features: z.array(z.string()).optional(),
})
    .strict();
